// The attributes that keep Next Steps text out of session replays, and the
// selectors the recorders are configured with, kept together so they cannot
// drift apart: mixins/PrivateRegion stamps the attributes, utils/mixpanel.js
// reads the selectors, and RichTextEditor.vue carries the block attribute in
// its template. docs/plans/2026-09-02-next-steps-e2e-encryption.md, section 7.

/** Mixpanel: every text node under an element carrying this is asterisked. */
export const PRIVATE_TEXT_ATTR = 'data-private';
/** Mixpanel: an element carrying this is recorded as a placeholder box. */
export const PRIVATE_BLOCK_ATTR = 'data-private-block';
/** Datadog RUM: `mask` hides text and inputs under the element, keeps the replay. */
export const DATADOG_PRIVACY_ATTR = 'data-dd-privacy';

export const PRIVATE_REGION_ATTRS = Object.freeze({
  [PRIVATE_TEXT_ATTR]: '',
  [DATADOG_PRIVACY_ATTR]: 'mask',
});

export const REPLAY_MASK_TEXT_SELECTOR = `[${PRIVATE_TEXT_ATTR}], [${PRIVATE_TEXT_ATTR}] *`;
export const REPLAY_BLOCK_SELECTOR = `[${PRIVATE_BLOCK_ATTR}]`;
